import { useKanbanBoardEmptyColumnStyles } from 'components/UI/V2/KanbanBoard/EmptyColumn/KanbanBoardEmptyColumn.styles';
import React from 'react';

export const KanbanBoardEmptyColumn: React.FC = () => {
    const classes = useKanbanBoardEmptyColumnStyles();

    return (
        <div className={classes.root}>
            <img
                src="/images/bookings/empty.svg"
                alt="Empty"
            />
            <h6 className={classes.title}>Don&apos;t get too comfy.</h6>
            <p className={classes.description}>This will fill up soon enough.</p>
        </div>
    );
};
